<script>
  import { layoutMethods,cifMethods,exportMethods,erpFixMessages } from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Swal from 'sweetalert2';
  /**
   * CIF Mobile Number Tab
   */
  export default {
    page: {
      title: "CIF Mobile Number Tab"
    },
    components: {
      flatPickr
    },
    computed: {
      ...erpFixMessages,
    },
    data() {
      return {
        title: "CIF Mobile Number Tab",
        searchValue: {
          searchField: null,
          search: null,
          changeType: null,
          netbankStatus: null,
          peddlrStatus: null,
          dateRange: null,
          sort: 'id',
          orderDesc: true,
          page: 1,
          rows: 10
        },
        searchList: [
          { text: "Search All", value: null },
          { text: "Reference Number", value: "referrenceNo" },
          { text: "Merchant Name", value: "merchantName" },
          { text: "New Mobile Number", value: "oldMobileNumber" },
          { text: "Old Mobile Number", value: "newMobileNumber" },
          { text: "Business Name", value: "businessName" },
        ],
        changeTypeOptions: [
          { text: "Search All", value: null },
          { text: "Mobile", value: "mobile" },
          { text: "Manual", value: "manual" }
        ],
        netbankStatusOptions: [
          { text: "Search All", value: null },
          { text: "Pending", value: "pending" },
          { text: "Confirmed", value: "success" },
          { text: "Failed", value: "failed" },
        ],
        peddlrDbStatusOptions: [
          { text: "Search All", value: null },
          { text: "Not Reflected", value: 0 },
          { text: "Reflected to DB ", value: 1 }
        ],
        rangeOptions: {
          mode: "range",
        },
        fields: [
          {key: "referrenceNo", sortable: true, label: 'Reference Number'},
          {key: "merchantName", sortable: true, label: 'Merchant Name'},
          {key: "oldMobileNumber", sortable: true, label: 'Old Mobile Number'},
          {key: "newMobileNumber", sortable: true, label: 'New Mobile Number'},
          {key: "changeType", sortable: true, label: 'Change Type', class: 'text-capitalize'},
          {key: "netbankStatus", sortable: true, label: 'Netbank Status'},
          {key: "peddlrDbStatus", sortable: true, label: 'Peddlr DB Status'},
          {key: "businessName", sortable: true, label: 'Business Name'},
          {key: "emailAddress", sortable: true, label: 'Email Address'},
          {key: "processDate", sortable: true, label: 'Process Date'},
        ],
        tableData: [],
        tableTotal: 0,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      }
    },
    methods: {
      ...layoutMethods,
      ...cifMethods,
      ...exportMethods,
      async onExport(){
        await this.onSearch();
        if(this.tableTotal ==0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        let params = Object.assign(
          {
            ...this.searchValue,
            module: 'cif_mobile_number',
            email: JSON.parse(localStorage.getItem('userData')).email
          });

        delete params.page;
        delete params.rows;
        
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
      async onSearch(state){
        this.tableData = [];
        console.log(">>> status", state,JSON.stringify(this.searchValue));
          if(state == 'reset'){
            this.searchValue.page = 1;
          }

          await this.actionCIF({
              action: "cif-mobile-number-list",
              body: this.searchValue
          }).then((res)=>{//
              this.tableData = res.message.rows
              this.tableTotal= res.message.pageInfo.total
              // console.log("res",JSON.stringify(res));
          }).catch((err)=>{
              console.log("err", err);
              this.tableData = []
              this.tableTotal= 0
          })
      },
      tableSort(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        // console.log(">> sorting...",ctx);
        this.onSearch('reset');
      },
    },
    async mounted(){
      // alert("hey cif mobile number");
      await this.onSearch('reset')
    }
  }
</script>



<template>
  <div><!-- outer div-->
    <h5 class="float-start card-title text-dark">
        <span class="fw-normal ms-lg-2"> {{ tableTotal }} </span> Record(s)
    </h5>
    <div class="d-flex flex-wrap flex-row-reverse">
        <a class="btn btn-secondary h-fit" @click="onSearch()">
          <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather> Refresh
        </a>
    </div>

    <div class="d-flex flex-wrap my-2">
      <div class="me-2 ta-right">
        <b-form-group description="Search Keyword">
          <form class="d-flex" @submit.prevent="onSearch('reset')">
            <b-form-group id="input-group-3" label-for="input-3">
              <b-form-select
                class="form-select rounded-0 rounded-start shadow-none"
                id="input-3"
                v-model="searchValue.searchField"
                :options="searchList"
              ></b-form-select>
            </b-form-group>

            <b-input-group>
              <b-form-input
                class="rounded-0"
                v-model="searchValue.search"
                placeholder=""
              ></b-form-input>
            </b-input-group>
          </form>
        </b-form-group>
      </div>
      <div class="me-2 ta-right">
        <b-form-group label-for="change-type" description="Filter by Change Type">
          <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
            id="change-type"
            v-model="searchValue.changeType"
            :options="changeTypeOptions"
          ></b-form-select>
        </b-form-group>
      </div>
      <div class="me-2 ta-right">
        <b-form-group label-for="netbank-status" description="Filter by Netbank Status">
          <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
            id="netbank-status"
            v-model="searchValue.netbankStatus"
            :options="netbankStatusOptions"
          ></b-form-select>
        </b-form-group>
      </div>
      <div class="me-2 ta-right">
        <b-form-group label-for="peddlr-status" description="Filter by Peddlr Status">
          <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
            id="peddlr-status"
            v-model="searchValue.peddlrStatus"
            :options="peddlrDbStatusOptions"
          ></b-form-select>
        </b-form-group>
      </div>
      <div class="me-2 ta-right">
        <b-form-group description="Filter by Date Range">
          <flat-pickr
            v-model="searchValue.dateRange"
            :config="rangeOptions"
            placeholder="Select a Date Range"
            class="form-control"
            style="width: fit-content"
          ></flat-pickr>
        </b-form-group>
      </div>
      <div class="me-2">
        <a class="btn btn-primary h-fit" @click="onSearch('reset')">
          <i class='bx bx-search bx-fw'></i>Search
        </a>
      </div>
      <div class="me-2">
        <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
          <i class="uil uil-export me-1"></i>
          Export
        </a>
      </div>
    </div><!--end of search value -->

    <div><!--table-->
      <!-- {{ searchValue }} -->
      <div class="table-responsive">
        <div class="table align-middle table-nowrap">
          <b-table
            :items="tableData"
            :fields="fields"
            responsive="sm"
            :current-page="searchValue.page"
            class="table-check"
            @sort-changed="tableSort" 
          >
            <template #cell(merchantName)="data">
              <span class="text-body m-0">
                <router-link :to="{ name: 'Profile Information', params: { tab: 'Profile', bid: data.item.businessId}}" class="customer-name" target="_blank">
                  {{ data.item.merchantName || data.item.users_id | truncator(20,'...')}}
                </router-link>
              </span>
            </template>
            <template #cell(netbankStatus)="data">
              <span :class="{
                  'text-success': data.item.netbankStatus== 'success',
                  'text-warning': data.item.netbankStatus== 'pending',
                  'text-danger': data.item.netbankStatus== 'failed'
                }">
                {{
                  data.item.netbankStatus == "success" ? 
                    "Confirmed" : 
                    (data.item.netbankStatus == "pending"? 
                     "Pending" :
                     "Failed" 
                    )
                }}
              </span>
            </template>
            <template #cell(peddlrDbStatus)="data">
              <span :class="{
                  'text-success': data.item.peddlrDbStatus== 1,
                  'text-danger': data.item.peddlrDbStatus== 0
                }">
                {{
                  data.item.peddlrDbStatus == 1 ? 
                    "Reflected to DB" : 
                    "--"
                }}
              </span>
            </template>
            <template #cell(emailAddress)="data">
              {{ data.item.emailAddress | notEmpty }}
            </template>
            <template #cell(oldMobileNumber)="data">
              {{ data.item.oldMobileNumber | notEmpty }}
            </template>
            <template #cell(newMobileNumber)="data">
              {{ data.item.newMobileNumber | notEmpty }}
            </template>
            <template #cell(processDate)="data">
              {{ data.item.processDate | formatDate }}
            </template>
          </b-table>
        </div>
      </div>
      <div class="row g-0 text-center" v-if="tableTotal == 0">
        <span>No data to display.</span>
      </div>

      <div class="row" v-if="tableTotal != 0 && tableTotal > searchValue.rows">
        <div class="col">
          <div class="form-group row pull-left">
            <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
            <div class="col-sm-6">
              <b-form-group label-for="display-record">
                <b-form-select class="form-select shadow-none w-fit"
                  id="display-record"
                  v-model="searchValue.rows"
                  :options="pageOptions"
                  @change="onSearch('reset')"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
          <div
            class="
              dataTables_paginate
              paging_simple_numbers
              float-end
            "
          >
            <b-pagination
              v-if="tableTotal != 0 && tableTotal > searchValue.rows"
              class="pagination-rounded"
              v-model="searchValue.page"
              :total-rows="tableTotal"
              @input="onSearch()"
              :per-page="searchValue.rows"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div><!--end of tbl-->
  </div> <!-- end of outer div-->
</template>



<style>
</style>